import { useTranslation } from "react-i18next";
import { MdCheck, MdHotel, MdLocationOn, MdStar } from "react-icons/md";
import hotelsImage from "src/assets/images/LandingPage/Hotels.png";

const STARS = 5;

export default function Hotel() {
  const { t } = useTranslation();
  return (
    <div className="flex w-90 flex-col overflow-hidden rounded-2xl bg-background-default font-poppins drop-shadow-lg" aria-hidden={true}>
      <div className="flex h-11 shrink-0 items-center justify-between bg-background-primary px-5 text-white">
        <div className="text-xs font-semibold uppercase tracking-widest">{t("Landing.decor.hotel.label")}</div>
        <MdHotel className="size-5" />
      </div>
      <div className="flex items-center gap-4 px-5 pt-4 pb-4">
        <img src={hotelsImage} alt="" className="size-20 shrink-0 rounded-xl object-cover" />
        <div className="flex flex-col gap-1">
          <span className="text-xl font-semibold">{t("Landing.decor.hotel.title")}</span>
          <div className="flex items-center text-yellow-60">
            {Array.from({ length: STARS }, (_, index) => (
              <MdStar key={index} className="size-4" />
            ))}
          </div>
          <div className="flex items-center gap-1 text-sm">
            <MdLocationOn className="size-4 shrink-0" />
            <span>{t("Landing.decor.hotel.location")}</span>
          </div>
        </div>
      </div>
      <div className="mx-5 border-t border-dashed border-border-default" />
      <div className="flex items-end justify-between px-5 pt-4">
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-widest">{t("Landing.decor.hotel.checkIn")}</span>
          <span className="text-sm font-semibold">{t("Landing.decor.hotel.checkInDate")}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-widest">{t("Landing.decor.hotel.checkOut")}</span>
          <span className="text-sm font-semibold">{t("Landing.decor.hotel.checkOutDate")}</span>
        </div>
        <div className="flex flex-col items-end">
          <span className="text-xs uppercase tracking-widest">{t("Landing.decor.hotel.room")}</span>
          <span className="text-sm font-semibold">{t("Landing.decor.hotel.roomValue")}</span>
        </div>
      </div>
      <div className="flex items-center justify-between px-5 pt-3 pb-4">
        <span className="text-lg font-bold text-font-active">{t("Landing.decor.points", { value: "42,000" })}</span>
        <div className="flex items-center gap-1 rounded-full bg-background-success px-3 py-1 text-xs font-semibold text-font-success">
          <MdCheck className="size-4" />
          {t("Landing.decor.hotel.confirmed")}
        </div>
      </div>
    </div>
  );
}
